module.exports = __webpack_public_path__ + "static/ProductMarketFit.48cde350.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/ProductMarketFit.svg
// module id = 342
// module chunks = 255246127382036